function updateContent(id) {
  const headerGlobal = document.querySelector(".header-global");
  const headerGlobalButtons = document.querySelectorAll(".header-global a");

  const chosenButton = headerGlobalButtons[id];
  if(chosenButton){
    chosenButton.classList.add("active");
  const backgroundColor = chosenButton.getAttribute("data-color");
  headerGlobal.style.backgroundColor = backgroundColor;
  const announcementBars = document.querySelectorAll('.announcement-bar');
  if (announcementBars)  {
    announcementBars.forEach((announcementBar) => {
      announcementBar.style.backgroundColor = backgroundColor;
      announcementBar.style.borderBottomColor = backgroundColor;
    });
  }

  const currentTagSearch = chosenButton.getAttribute('data-tag-for-search');
  const searchFormInputs = document.querySelectorAll("form[role='search'] .search__input");
  if (searchFormInputs) {
    searchFormInputs.forEach((searchFormInput) => {
      searchFormInput.setAttribute('data-tag', currentTagSearch);
    });
  }
}
}
function setGlobalActive() {
  const globalIndex = getGlobalIndex();
  if (globalIndex >= 0) {
    updateContent(globalIndex);
  }
}
setGlobalActive();

/* --------------------------------------------------------- */

window.dropDownHoverId = "";
function initDetailsMenu() {
  const menuDetails = document.querySelectorAll(".header-item details");
  
  [...menuDetails].map((menuDetail, index) => {
    menuDetail.addEventListener("mouseover", function (e) {
      e.currentTarget.isHover = true;
      setTimeout(
        function (currentTarget) {
          if (currentTarget.isHover) currentTarget.setAttribute("open", "");
        },
        50,
        e.currentTarget
      );
    });
    menuDetail.addEventListener("mouseout", function (e) {
      e.currentTarget.isHover = false;
      setTimeout(
        function (currentTarget) {
          if (!currentTarget.isHover) currentTarget.removeAttribute("open");
        },
        50,
        e.currentTarget
      );
    });
  });

  const dropDowns = document.querySelectorAll(
    ".site-nav__dropdown, .site-nav__dropdown a"
  );
  [...dropDowns].map((dropDown, index) => {
    dropDown.addEventListener("mouseover", function (e) {
      window.dropDownHoverId = e.currentTarget
        .closest("details")
        .getAttribute("data-detail-id");
    });
    dropDown.addEventListener("mouseout", function (e) {
      window.dropDownHoverId = "";
      const parentDetails = e.currentTarget.closest("details");

      setTimeout(
        function (currentTarget) {
          if (!currentTarget.isHover && window.dropDownHoverId == "")
            currentTarget.removeAttribute("open");
        },
        50,
        e.currentTarget
      );
    });
  });
}
/* --------------------------------------------------------- */

function setGlobaIndex(globalIndex) {
  localStorage.setItem("globalIndex", globalIndex);
}

function getGlobalIndex() {
  const localStorageGlobal = localStorage.getItem("globalIndex");
  return typeof localStorageGlobal !== "undefined" ? localStorageGlobal : 0;
}

function changeGlobalIndex(globalIndex, href) {
  setGlobaIndex(globalIndex);
  window.top.location.href = href;
}

function initGlobalChange() {
  const headerGlobal = document.querySelector(".header-global");
  if(headerGlobal){
        const globalButtons = headerGlobal.querySelectorAll(".site-nav__item");

  [...globalButtons].map((globalButton, index) => {
    globalButton.index = index;
    globalButton.addEventListener("click", function (event) {
      event.preventDefault();
      changeGlobalIndex(event.target.index, event.target.getAttribute("href"));
    });
  });
  }

}

function initInternationalTabs() {
  const pageWithTabsTabs = document.querySelectorAll(".page-with-tabs--tab");
  if (pageWithTabsTabs) {
    pageWithTabsTabs.forEach((pageWithTabsTab) => {
      pageWithTabsTab.addEventListener("click", function (event) {
        event.preventDefault();

        eventTarget = event.target;

        if (eventTarget.classList.contains("active")) {
          eventTarget.closest(".page-with-tabs--tabs").classList.toggle("open");
        } else {
          let container = eventTarget.closest(".page-with-tabs");
          container.querySelector(".page-with-tabs--tabs").classList.remove("open");
          container.querySelectorAll(".page-with-tabs--tab").forEach((tab) => {
            tab.classList.remove("active");
          });
          eventTarget.classList.add("active");
          container
            .querySelectorAll(".page-with-tabs--tab-content")
            .forEach((tabContent) => {
              tabContent.classList.remove("active");
            });

          container
            .querySelector(
              `.page-with-tabs--tab-content[data-tab="${eventTarget.getAttribute(
                "data-tab"
              )}"]`
            )
            .classList.add("active");
        }
      });
    });
  }
}

function initSearchFields() {
  const inputItems = document.querySelectorAll(".search__input--visible");

  if (inputItems) {
    inputItems.forEach((inputItem) => {
      const nextSibling = inputItem.nextElementSibling;

      if (nextSibling.classList.contains('search__input--hidden') ) {
        inputItem.addEventListener('input', function (evt) {
          if ( this.hasAttribute('data-tag') ) {
            const queryValue = 'tag:' + this.getAttribute('data-tag') + '+AND+' + this.value;

            nextSibling.value = queryValue;
            nextSibling.dispatchEvent(new Event('input'));
            nextSibling.style.display = 'none';
          }
        });
      }
    });
  }

  const searchForms = document.querySelectorAll("form[role='search']");
  if (searchForms) {
    searchForms.forEach((form) => {
      form.onsubmit = function(event){
        event.preventDefault();
        
        const data = new FormData(form);
        const formURL = form.getAttribute('action');
        let searchParams = '';
        for (let entry of data) {
          if (searchParams != '') searchParams += "&";
          let valToAddToURL = '';
          if (entry[0] != 'q-input') {
            const valToAdd = entry[1];
            if ( valToAdd.includes('+AND+') ){
              const valToAddArr = entry[1].split('+AND+');
              valToAddToURL = encodeURI(valToAddArr[0]) + "+AND+" + encodeURI(valToAddArr[1]);
            } else {
              valToAddToURL = encodeURI(valToAdd);
            }
            searchParams += encodeURI(entry[0]) + '=' + valToAddToURL;
          }
        }
        window.top.location.href = formURL + "?" + searchParams;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initSearchFields();
  initGlobalChange();
  initDetailsMenu();
  initInternationalTabs();
});


